module.exports = __webpack_public_path__ + "img/google.da3a9ed4.svg";